module.exports = __webpack_public_path__ + "img/3.84c66af5.png";